module.exports = __webpack_public_path__ + "assets/images/clients/5.jpg";